export const selectContentSearchOptions = (state) => state.content.contentSearchOptions;